/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useState } from 'react'

import { Button, Col, Form, PageHeader, Row, Skeleton, Table } from 'antd'
import { MaskedInput } from 'antd-mask-input'
import { SelectFieldAnt } from 'Components/Form'
import DateSelector from 'Components/Form/DateSelector'
import PesquisaVeiculo from 'Components/Form/PesquisaVeiculo'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import Veiculos from 'Helpers/Veiculos'
import { Veiculo } from 'Models/cadastros'
import { IHorario } from 'Models/docas'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import IFormVeiculosFilter from 'Views/Cadastros/Veiculos/IFormVeiculosFilter'

import IFormDocasBucasPorPlacaFilter from '../../../Models/docas/IFormDocasBuscaPorPlacaFilter'
import { DocasContext } from '../Context/context'

const ModalBuscaPorPlaca = () => {
  const [form] = Form.useForm()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const [agenda, setAgenda] = useState<IHorario[]>([])
  const [veiculoSelecionado, setVeiculoSelecionado] = useState<Veiculo>()
  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)

  const pesquisaAgenda = async (filtros: IFormDocasBucasPorPlacaFilter) => {
    if (veiculoSelecionado) {
      filtros.dataInicio = filtros.dataInicioMoment.format(
        'YYYY-MM-DD HH:mm:ss',
      )

      if (filtros.dataFimMoment) {
        filtros.dataFim = filtros.dataFimMoment.format('YYYY-MM-DD HH:mm:ss')
      }

      filtros.placa = veiculoSelecionado.placa

      try {
        const { data } = await WsDocasService.agenda.pesquisaPorPlaca(
          ID_COMPONENTE.DOCAS,
          filtros,
        )

        if (data.items) {
          setAgenda(data.items)
        }
      } catch (e) {
        alert('Não foram encontradas agendas no intervalo de datas informado')
      }
    } else {
      alert('Informe um veículo para pesquisa')
    }

    setCarregandoPesquisa(false)
  }

  return (
    <>
      <Form onFinish={pesquisaAgenda} layout="vertical" form={form}>
        <PageHeader
          ghost={false}
          title={'Pesquisar Agenda'}
          extra={[
            <Button
              key="pesquisar"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              onClick={() => setCarregandoPesquisa(true)}
              disabled={!veiculoSelecionado}
            >
              Pesquisar
            </Button>,
          ]}
        >
          <Row gutter={16}>
            <Col span={6}>
              <DateSelector
                name="dataInicioMoment"
                label="Data Inicial:"
                showTime={true}
                currentTime={false}
                initialValue={moment()}
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              />
            </Col>

            <Col span={6}>
              <DateSelector
                name="dataFimMoment"
                label="Data Final:"
                showTime={true}
              />
            </Col>

            <Col span={12}>
              <PesquisaVeiculo
                form={form}
                veiculoSelecionado={veiculoSelecionado}
                setVeiculoSelecionado={setVeiculoSelecionado}
                selecionarPrimeiroVeiculoEncontrado={true}
                rules={[{ required: true, message: 'Campo obrigatório' }]}
              />
            </Col>
          </Row>
        </PageHeader>
      </Form>

      <Row>
        <Col span={24}>
          <Table
            pagination={false}
            scroll={{ y: 450 }}
            columns={[
              {
                title: 'Data/Hora',
                key: 'dtHora',
                dataIndex: 'dtHora',
                render: (dtHora: string) =>
                  moment(dtHora).format('DD/MM/YYYY HH:mm:SS'),
              },
              {
                title: 'Armazém',
                key: 'nomeArmazem',
                dataIndex: 'nomeArmazem',
              },
              {
                title: 'Doca',
                key: 'nomeDoca',
                dataIndex: 'nomeDoca',
              },
              {
                title: 'Janela',
                key: 'nomeJanela',
                dataIndex: 'nomeJanela',
              },
              {
                title: 'Motorista',
                key: 'nomeMotorista',
                dataIndex: 'nomeMotorista',
              },
              {
                title: 'Empresa',
                key: 'nomeEntidade',
                dataIndex: 'nomeEntidade',
              },
              {
                title: 'Oferta',
                key: 'numeroOferta',
                dataIndex: 'numeroOferta',
              },
              {
                title: 'Confirmado',
                key: 'confirmado',
                dataIndex: 'confirmado',
                render: (confirmado: boolean) => (confirmado ? 'Sim' : 'Não'),
              },
              {
                title: 'Alerta',
                key: 'temAlerta',
                dataIndex: 'temAlerta',
                render: (temAlerta: boolean) => (temAlerta ? 'Sim' : 'Não'),
              },
            ]}
            dataSource={agenda}
          />
        </Col>
      </Row>
    </>
  )
}

export default ModalBuscaPorPlaca
